





































































































































import './ResetPasswordForm.less'

import {Component, Prop, Vue} from 'vue-property-decorator'
import {Validations} from 'vuelidate-property-decorators'
import {required} from 'vuelidate/lib/validators'
import {ResetPasswordService} from '@/services/clientService.ts'
import {getTrans} from '@/services/transService.ts'
import axios from "axios";

const passwordValidator = value => {
  const regex = /^(?=.*[0-9])^(?=.*[A-Z])(?=.*[a-zA-Z])\S{7,}\S$/
  return regex.test(value)
}
const passwordValidatorMinUppercase = value => {
  const regex = /^(?=.*[A-Z])/
  return regex.test(value)
}
const passwordValidatorMinNumber = value => {
  const regex = /^(?=.*[0-9])/
  return regex.test(value)
}
const passwordValidatorMin8 = value => {
  const regex = /^\S{8,}$/
  return regex.test(value)
}

const emailValidator = email => {
  const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return regex.test(String(email).toLowerCase())
}

@Component
export default class ResetPasswordForm extends Vue {
  @Prop() private email!: string
  @Prop() private token!: string
  @Prop() private resetRoute!: string
  public formModel = {
    email: this.email,
    token: this.token,
    password: '',
  }
  public isApiError = false
  public isApiSuccess = false
  public isLoading = false
  public inputType = 'password'
  public $v

  trans(key) {
    return getTrans(key)
  }

  mounted() {
    this.formModel.password = ''
  }

  inputTypeToogle() {
    if (this.inputType === 'password') {
      this.inputType = 'text'
    } else {
      this.inputType = 'password'
    }
  }

  submit() {
    if (this.$v.formModel.$invalid) {
      this.$v.formModel.$touch()
    } else {
      this.isLoading = true
      ResetPasswordService(
          this.formModel.email,
          this.formModel.token,
          this.formModel.password,
          this.resetRoute,
      )
          .then(() => {
            this.isLoading = false
            this.isApiSuccess = true
            this.formModel.password = ''
          })
          .catch(response => {
            if(!response.response) {
              return false
            }
            this.isLoading = false
            this.isApiError = true
            console.log(JSON.parse(response.request.response))
            this.formModel.password = ''
          })
    }
  }

  back() {
    location.href = '/login'
  }

  @Validations()
  validations = {
    formModel: {
      password: {
        required,
        passwordValidator: passwordValidator,
        passwordValidatorMin8: passwordValidatorMin8,
        passwordValidatorMinUppercase: passwordValidatorMinUppercase,
        passwordValidatorMinNumber: passwordValidatorMinNumber,
      },
    },
  }
}
